import { style } from 'typestyle';
import { UserLogin } from '../../components/LoginForm';
import { ADALONG_COLORS } from '../../styles';
import logo from '../../assets/img/site/logo_alone_white.png';

function Login() {
  return (
    <div className={login}>
      <main className={main}>
        <div className={logoContainer}>
          <img src={logo} className={logoImg} alt="Logo" />
          <span className={adminText}>Admin</span>
        </div>
        <UserLogin />
      </main>
    </div>
  );
}

export default Login;

const login = style({ 
  minHeight: '100vh', 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center',
  backgroundColor: ADALONG_COLORS.SMOOTH_BLACK,
});

const main = style({ 
  width: '100%', 
  maxWidth: 400, 
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const logoContainer = style({
  marginBottom: 30,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
});

const logoImg = style({
  height: 80,
  padding: "15px 0 15px 15px"
});

const adminText = style({
  fontFamily: '"Public Sans", sans-serif',
  fontSize: 40,
  color: ADALONG_COLORS.LIGHT_WHITE,
});
